import { useMemo } from 'react';
import { useFilterContext } from 'src/contexts/FilterContext';
import { useStores } from './store-selection/queries/useStores';
import { useStoreType } from './useStoreType';

export const useFilterStoreOptions = () => {
    const [filterContext] = useFilterContext();
    const storeType = useStoreType();
    const { data } = useStores(filterContext.grouping, storeType, filterContext);
    const { chains, clusters, partners, countries } = data;

    const filterOptions = useMemo(
        () => ({
            chains: chains.map((chain) => ({
                label: chain.name,
                value: chain.id,
            })),
            countries: countries.map((country) => ({
                label: country.name,
                value: country.id,
            })),
            clusters: clusters.map((cluster) => ({
                label: cluster.name,
                value: cluster.name,
            })),
            partners: partners.map((partner) => ({
                label: partner.name,
                value: partner.id,
            })),
        }),
        [chains, countries, clusters, partners]
    );

    return { filterOptions };
};
